import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['source', 'label']
  static values = {
    copyLabel: String,
    copiedLabel: String
  }

  disconnect() {
    window.clearTimeout(this.resetTimer)
  }

  async copy() {
    if (!this.hasSourceTarget) return

    const text = 'value' in this.sourceTarget
      ? this.sourceTarget.value
      : this.sourceTarget.textContent.trim()

    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard API unavailable')
      await navigator.clipboard.writeText(text)
    } catch {
      this.copyWithFallback(text)
    }

    if (!this.hasLabelTarget) return

    this.labelTarget.textContent = this.copiedLabelValue
    window.clearTimeout(this.resetTimer)
    this.resetTimer = window.setTimeout(() => {
      if (this.hasLabelTarget) this.labelTarget.textContent = this.copyLabelValue
    }, 1600)
  }

  copyWithFallback(text) {
    const input = document.createElement('textarea')
    input.value = text
    input.setAttribute('readonly', '')
    input.style.position = 'fixed'
    input.style.opacity = '0'
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    input.remove()
  }
}
